




















import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

@Component
export default class ConfirmThree extends Vue {
  @Prop({ default: false, type: Boolean })
  show!: boolean;

  @Prop()
  configOption!: any;

  handleOne(): void {
    this.$emit("one");
  }
  handleTwo(): void {
    this.$emit("two");
  }
  handleThree(): void {
    this.$emit("three");
  }
}
